var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisible({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382 4627 c-78 -78 -142 -147 -142 -152 0 -6 141 -151 314 -324 l314 -314 -92 -77 c-300 -254 -561 -602 -723 -964 l-54 -119 42 -96 c244 -556 664 -1014 1204 -1313 587 -324 1317 -420 1970 -257 87 22 321 96 345 110 11 6 108 -85 405 -381 l390 -390 148 148 147 147 -2063 2063 -2062 2062 -143 -143z m1320 -1624 l176 -178 -10 -65 c-19 -128 3 -250 67 -385 87 -180 229 -304 420 -366 59 -19 92 -23 218 -24 l147 0 175 -175 175 -174 -78 -32 c-275 -114 -582 -117 -859 -9 -374 147 -650 487 -719 886 -24 139 -15 342 20 473 25 94 76 226 86 226 3 0 85 -80 182 -177z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2265 4405 c-160 -18 -344 -56 -490 -101 -66 -20 -123 -40 -127 -43 -4 -4 104 -118 241 -255 l248 -248 84 27 c282 89 574 67 845 -65 400 -194 654 -598 654 -1041 0 -122 -20 -251 -55 -353 l-24 -71 337 -337 c185 -186 342 -338 349 -338 20 0 292 277 374 380 153 192 283 407 382 630 l38 86 -45 101 c-92 207 -229 433 -372 613 -92 116 -328 350 -444 439 -394 306 -818 488 -1302 562 -175 27 -524 34 -693 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2885 3010 c198 -198 364 -360 369 -360 9 0 2 93 -15 180 -14 73 -78 208 -129 273 -124 159 -335 267 -519 267 l-66 0 360 -360z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/invisible.72762b12c25e9e712de3bf7d0b5ccfc8.svg";
export { ForwardRef as ReactComponent };